import { render } from "./SocialList.vue?vue&type=template&id=9a4638b2&scoped=true"
import script from "./SocialList.vue?vue&type=script&lang=js"
export * from "./SocialList.vue?vue&type=script&lang=js"

import "./SocialList.vue?vue&type=style&index=0&id=9a4638b2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a4638b2"]])

export default __exports__